import { FC, useCallback } from 'react';
import { useForm } from 'react-final-form';

import { Button } from '@beeline/design-system-react/extracted-styles';

import { Panel } from 'src/components/Panel/Panel';
import { searchActions } from 'src/store/search/slice';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { SearchFiltersFields } from './SearchFiltersFields';
import { SearchFiltersForm } from './SearchFiltersForm';

const Actions: FC = () => {
  const dispatch = useAppDispatch();
  const { submit } = useForm();

  const applyFilters = useCallback(async () => {
    await submit();
    dispatch(sidesheetActions.close());
  }, [dispatch, submit]);

  const resetFilters = useCallback(() => {
    dispatch(searchActions.resetFilters());
    dispatch(sidesheetActions.close());
  }, [dispatch]);

  return (
    <>
      <Button
        variant='outlined'
        onClick={resetFilters}
        data-testid='resetSearchFilters'
      >
        Сбросить
      </Button>
      <Button
        variant='contained'
        onClick={applyFilters}
        data-testid='applySearchFilters'
      >
        Применить
      </Button>
    </>
  );
};

export const SearchFiltersSidesheetPanel: FC = () => {
  return (
    <SearchFiltersForm>
      <Panel actions={<Actions />}>
        <SearchFiltersFields />
      </Panel>
    </SearchFiltersForm>
  );
};
